export const HomeCSS = {
  homeContainer: {
    padding: "20px",
    margin: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontWeight: "600",
  },
  about: {
    maxWidth: "800px",
  },
  link: {
    textDecoration: "none",
    margin: '40px',
    color: "#112d4e",
    border: "2px solid #112d4e",
    width: "120px",
    padding: 5,
    backgroundColor: "transparent",
    borderRadius: '50px'
  },
  linkHover: {
    backgroundColor: "#112d4e",
    color: "#fff",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0,0,0,0.5)",
  },
  homeContent: {
    maxWidth: "800px",
    textAlign: "justify",
    fontWeight: "600",
  },

  h2: {
    color: "#112d4e",
    fontSize: "22pt",
    textAlign: "center",
  },

  p: {
    fontSize: "18px",
    color: "#666",
    lineHeight: "1.6",
  },
};
